"use strict";
////////////////////////////////////////////////////////////
// Strings
////////////////////////////////////////////////////////////
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeProtocol = exports.getSizedImageUrl = exports.getImageSize = exports.snakeCase = exports.sentenceCase = exports.pathCase = exports.pascalCase = exports.kebabCase = exports.noCase = exports.headerCase = exports.dotCase = exports.constantCase = exports.capitalCase = exports.camelCase = void 0;
var change_case_1 = require("change-case");
Object.defineProperty(exports, "camelCase", { enumerable: true, get: function () { return change_case_1.camelCase; } });
Object.defineProperty(exports, "capitalCase", { enumerable: true, get: function () { return change_case_1.capitalCase; } });
Object.defineProperty(exports, "constantCase", { enumerable: true, get: function () { return change_case_1.constantCase; } });
Object.defineProperty(exports, "dotCase", { enumerable: true, get: function () { return change_case_1.dotCase; } });
Object.defineProperty(exports, "headerCase", { enumerable: true, get: function () { return change_case_1.headerCase; } });
Object.defineProperty(exports, "noCase", { enumerable: true, get: function () { return change_case_1.noCase; } });
Object.defineProperty(exports, "kebabCase", { enumerable: true, get: function () { return change_case_1.paramCase; } });
Object.defineProperty(exports, "pascalCase", { enumerable: true, get: function () { return change_case_1.pascalCase; } });
Object.defineProperty(exports, "pathCase", { enumerable: true, get: function () { return change_case_1.pathCase; } });
Object.defineProperty(exports, "sentenceCase", { enumerable: true, get: function () { return change_case_1.sentenceCase; } });
Object.defineProperty(exports, "snakeCase", { enumerable: true, get: function () { return change_case_1.snakeCase; } });
////////////////////////////////////////////////////////////
// Images
////////////////////////////////////////////////////////////
var theme_images_1 = require("@shopify/theme-images");
Object.defineProperty(exports, "getImageSize", { enumerable: true, get: function () { return theme_images_1.imageSize; } });
Object.defineProperty(exports, "getSizedImageUrl", { enumerable: true, get: function () { return theme_images_1.getSizedImageUrl; } });
////////////////////////////////////////////////////////////
// URLS
////////////////////////////////////////////////////////////
/**
 * Strip the protocol from a URL
 * @param path URL
 * @returns URL without protocol
 */
function removeProtocol(path) {
    return path.replace(/^https?:/, '');
}
exports.removeProtocol = removeProtocol;
////////////////////////////////////////////////////////////
// Prices
////////////////////////////////////////////////////////////
// See currency.ts
//# sourceMappingURL=formatting.js.map